import type { Theme } from '@mui/material';
import type { Palette, PaletteColor } from '@mui/material/styles';

export const blendColor = (opacity: number, bg: string) => {
  const initialOpacity = opacity * 100;

  return `color-mix(in srgb, currentColor ${initialOpacity}%, ${bg} ${100 - initialOpacity}%)`;
};

export const getColorByChainString = (theme: Theme, colorString: string) =>
  colorString.split('.').reduce((acc: Palette | PaletteColor | string, key: string) => {
    const colorKey = key as keyof typeof acc;
    const colorGroup = acc[colorKey];

    if (!colorGroup) {
      return '';
    }

    return colorGroup as typeof colorGroup;
  }, theme.palette) as string;
